import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddUserlikeChatbotSettingsForm from './AddUserlikeChatbotSettingsForm';

export type UserlikeChatbotSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const UserlikeChatbotSettingsDrawer = ({ onClose, visible, moduleId }: UserlikeChatbotSettingsDrawerProps) => {
    const { t } = useTranslation(['userlikeChatbotModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('userlikeChatbotModuleDetails:settingsDrawer.cancelButton')}</Button>
                    <Button form="addUserlikeChatbotSettings" htmlType="submit" type="primary">
                        {t('userlikeChatbotModuleDetails:settingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('userlikeChatbotModuleDetails:settingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddUserlikeChatbotSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UserlikeChatbotSettingsDrawer;

export const useUserlikeChatbotSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UserlikeChatbotSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
